export default __webpack_public_path__ + "static/media/p5.4bd3ee79.jpeg";